/** JSON embedded in a script element must never contain a literal closing tag. */
export function jsonForHtml(value: unknown): string {
    return (JSON.stringify(value) ?? 'null').replace(/</g, '\\u003c');
}
